import React from 'react';

class ErrorBoundary extends React.Component {
  constructor(props) {
    super(props);
    this.state = { hasError: false };
  }

  static getDerivedStateFromError() {
    return { hasError: true };
  }

  componentDidCatch(error, errorInfo) {
    if (process.env.NODE_ENV === 'production') {
      // Future: send to Sentry, LogRocket, etc.
    }
  }

  handleReload = () => {
    window.location.href = '/';
  };

  render() {
    if (this.state.hasError) {
      return (
        <div className="min-h-screen bg-silk-50 flex items-center justify-center px-4">
          <div className="max-w-xl w-full text-center">
            <div className="inline-flex items-center justify-center w-20 h-20 rounded-full bg-gold/10 mb-6">
              <svg xmlns="http://www.w3.org/2000/svg" width="40" height="40" viewBox="0 0 24 24" fill="none" stroke="#D4AF37" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                <circle cx="12" cy="12" r="10"/>
                <line x1="12" y1="8" x2="12" y2="12"/>
                <line x1="12" y1="16" x2="12.01" y2="16"/>
              </svg>
            </div>

            <h1 className="text-5xl md:text-6xl font-serif font-bold text-hillpoint mb-4 tracking-tight">
              Oops
            </h1>

            <h2 className="text-2xl md:text-3xl font-serif font-bold text-charcoal mb-4">
              Something Went Wrong
            </h2>

            <p className="text-lg text-charcoal/70 max-w-md mx-auto leading-relaxed mb-10">
              We encountered an unexpected error. Please try refreshing the page or return to the homepage.
            </p>

            <div className="flex flex-col sm:flex-row gap-4 justify-center">
              <button
                onClick={() => window.location.reload()}
                className="px-8 py-4 bg-hillpoint text-white font-bold text-base tracking-wider uppercase hover:bg-hillpoint-light transition-colors duration-300"
              >
                Refresh Page
              </button>
              <button
                onClick={this.handleReload}
                className="px-8 py-4 border-2 border-gold text-gold font-bold text-base tracking-wider uppercase hover:bg-gold hover:text-hillpoint transition-all duration-300"
              >
                Go to Homepage
              </button>
            </div>

            <p className="text-sm text-charcoal/40 mt-12">
              If this problem persists, please{' '}
              <a href="/contact" className="text-gold underline hover:text-hillpoint transition-colors">
                contact us
              </a>.
            </p>
          </div>
        </div>
      );
    }

    return this.props.children;
  }
}

export default ErrorBoundary;
